export const DELETE_TEMPLATE_MODAL_TITLE = 'Delete Message Template';
export const DELETE_TEMPLATE_MODAL_SUBMIT = 'Delete Template';
export const EDIT_MESSAGE_TEMPLATE_MODAL_TITLE = 'Edit Message Template';
export const EDIT_MESSAGE_TEMPLATE_MODAL_SUBMIT = 'Save Template';
export const CREATE_MESSAGE_TEMPLATE_MODAL_TITLE = 'New Message Template';
export const CREATE_MESSAGE_TEMPLATE_MODAL_SUBMIT = 'Create Template';
export const CREATE_TEMPLATE_OPTION = 'create';
export const EDIT_TEMPLATE_OPTION = 'update';
export const DELETE_TEMPLATE_OPTION = 'delete';
